<template>
  <div class="lottery_image_toast_bg" v-if="toastShow">
    <div class="lottery_image_toast_bg">
      <img
        class="lottery_image_toast_image"
        v-if="dataModel != null"
        :src="dataModel.picture"
      />
      <div class="lottery_image_toast_title" v-if="dataModel != null">
        {{ dataModel.name }}
      </div>
      <button
        class="button lottery_image_toast_close"
        @click="$emit('isshowaction')"
      >
        <img
          class="lottery_image"
          src="../../assets/lottery/close_icon.png"
          alt="关闭"
        />
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from "vue-class-component";
import { Http, ResponseData } from "../../net/Http";
import { Urls } from "../../net/Urls";
import { PrizeModel } from "../../model/lottery/LotteryModel";
@Options({
  props: {
    toastShow: Boolean
  },
  emits: {
    isshowaction: () => {
      return true;
    }
  }
})
export default class LotteryImageToast extends Vue {
  private dataModel: PrizeModel | null = null;
  mounted() {
    this.getPrizeData();
  }
  getPrizeData() {
    Http.get<PrizeModel>(Urls.lottery_luckyValueAward).then(
      (res: PrizeModel) => {
        this.dataModel = res;
      },
      (err: ResponseData) => {
        console.log("LotteryImageToast:", err.message);
      }
    );
  }
}
</script>

<style scoped lang="less">
.lottery_image_toast_bg {
  position: fixed;
  z-index: 2000;
  left: 0px;
  right: 0;
  top: 44px;
  bottom: 0;
  text-align: center;
  background: rgba(17, 17, 17, 0.7);
  height: 100%;
  width: 100%;
  .lottery_image_toast_bg {
    width: 325px;
    height: 243px;
    position: fixed;
    z-index: 2100;
    left: 50%;
    top: 45%;
    transition: all 0.5s;
    -webkit-transform: translateX(-50%) translateY(-50%);
    -moz-transform: translateX(-50%) translateY(-50%);
    -ms-transform: translateX(-50%) translateY(-50%);
    -o-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
    text-align: center;
    border-radius: 10px;
    background-color: white;
    .lottery_image_toast_image {
      width: 100%;
      height: 100%;
      border-radius: 10px;
      object-fit: cover;
    }
    .lottery_image_toast_title {
      position: fixed;
      z-index: 2200;
      left: 50%;
      top: 80%;
      transform: translateX(-50%) translateY(-50%);
      text-align: center;
      font-size: 14px;
      color: #111111;
    }
    .lottery_image_toast_close {
      color: #ffffff;
      margin-top: 8px;
      .lottery_image {
        width: 36px;
        height: 36px;
      }
    }
  }
}
</style>
